<template>
  <v-card class="mr-3 ml-3 mb-3 pa-3">
    <v-card-title>
      <span class="headline">Редактирование Нашего ЮЛ</span>
      <v-spacer></v-spacer>
      <v-btn color="warning" text @click="back">Назад</v-btn>
    </v-card-title>
    <v-card-text>
      <v-form v-model="isValid" ref="form">
        <v-row>
          <v-col cols="12">
            <v-text-field 
              label="Название"
              v-model="ourLe.name"
              :rules="[notEmptyRule, length1024]"
              counter="1024"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field 
              label="ИНН"
              v-model="ourLe.inn"
              :rules="[length12]"
              counter="12"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field 
              label="КПП"
              v-model="ourLe.kpp"
              :rules="[length9]"
              counter="9"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field 
              label="Адрес ЮЛ"
              v-model="ourLe.address"
              :rules="[length1024]"
              counter="1024"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field 
              label="№ р/с"
              v-model="ourLe.numbRs"
              :rules="[length20]"
              counter="20"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field 
              label="БИК"
              v-model="ourLe.bik"
              :rules="[length9]"
              counter="9"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field 
              label="Название банка"
              v-model="ourLe.bankName"
              :rules="[length1024]"
              counter="1024"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field 
              label="Номер к/с"
              v-model="ourLe.numbKs"
              :rules="[length20]"
              counter="20"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-switch
          label="Связь с 1С"
          inset
          v-model="ourLe.onecConnection"
          @change="ourLe.onecDataUpdate = true"
        ></v-switch>
        <v-card :disabled="!ourLe.onecConnection">
          <v-card-title>
            <span>Настройка связи с 1С</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field 
                  label="URL API"
                  v-model="ourLe.onecUrl"
                  :rules="[notEmptyRuleOneC]"
                  :disabled="!ourLe.onecConnection"
                  @input="onecConnected = false; ourLe.onecDataUpdate = true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field 
                  label="Имя пользователя"
                  v-model="ourLe.onecLogin"
                  :disabled="!ourLe.onecConnection"
                  @input="onecConnected = false; ourLe.onecDataUpdate = true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field 
                  label="Пароль"
                  type="password"
                  v-model="ourLe.onecPassword"
                  :disabled="!ourLe.onecConnection"
                  @input="onecConnected = false; ourLe.onecDataUpdate = true"
                ></v-text-field>
              </v-col>
              <v-col>
    
              </v-col>
              <v-col cols="auto">
                <v-btn :loading="loadingConnection" :disabled="!ourLe.onecConnection || !ourLe.onecDataUpdate" text color="orange darken-3" @click="checkOnecConnection">
                  Проверить связь с 1С
                </v-btn>
              </v-col>
            </v-row> 
          </v-card-text>
        </v-card>
        <v-row class="mt-3">
          <v-col cols="12" sm="6">
            <v-text-field
              label="Изменил"
              v-model="ourLe.creatorName"
              disabled
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Дата последнего изменения"
              v-model="formatUpdateTime"
              disabled
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary darken-1" text @click="updateOurLe" :loading="loadingSave"
             :disabled="!isValid || (ourLe.onecConnection && !onecConnected)">Сохранить
      </v-btn>
    </v-card-actions>

    <v-overlay :z-index="0" :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import API from "@/axios/api";

import FormatDateTime from "@/utils/time.js";

export default {
  name: 'OurLegalEntityEdit',
  props: ['ourLeId'],
  data() {
    return {
      loading: true,
      ourLe: {},
      onecConnected: false,
      loadingConnection: false,
      loadingSave: false,
      isValid: false,
      notEmptyRule: v => !!v || 'Поле не может быть пустым',
      notEmptyRuleOneC: v => !this.ourLe.onecConnection || !!v || 'Поле не может быть пустым',
      length1024: v => (v == undefined || v.length <= 1024) || 'Максимум 1024 символов',
      length20: v => (v == undefined || v.length <= 20) || 'Максимум 20 цифр',
      length12: v => (v == undefined || v.length <= 12) || 'Максимум 12 цифр',
      length9: v => (v == undefined || v.length <= 9) || 'Максимум 9 цифр',
    }
  },
  methods: {
    back() {
      history.back();
    },
    async getOurLeData() {
      await API.get(`our_legal_entities/${this.ourLeId}`)
        .then((response) => {
          console.log(response.data)
          this.ourLe = response.data.ourLegalEntity
        })
        .catch((error) => {
          console.eror(error)
          if (error.response.data.message)
          this.$store.commit("showSnackbar", {
            color: "error",
            text: error.response.data.message,
          })
        })
    },
    checkOnecConnection() {
      this.loadingConnection = true
      API.post('our_legal_entities/onec/check', {
        url: this.ourLe.onecUrl,
        login: this.ourLe.onecLogin,
        password: this.ourLe.onecPassword
      })
        .then((response) => {
          console.log(response)
          this.$store.commit('showSnackbar', {
            color: 'success',
            text: 'Связь присутствует.'
          })
          this.onecConnected = true
          this.loadingConnection = false
        })
        .catch((error) => {
          console.log(error)
          this.loadingConnection = false
        })
    },
    updateOurLe() {
      this.loadingSave = true
      setTimeout(
        () =>
          API.post(`our_legal_entities/${this.ourLeId}`, this.ourLe)
            .then((response) => {
              console.log(response.data);
              this.$store.commit("showSnackbar", {
                color: "success",
                text: "Информация обновлена",
              });
              this.loadingSave = false
              this.loading = true
              this.$store.dispatch("updateOurLegalEntities")
              this.$store.dispatch('initOnecStream')
              this.getOurLeData()
                .then(() => {
                  this.$refs.form.validate();
                  this.loading = false;
                });
              })
              .catch((error) => {
                console.log(error);
                this.$store.commit("showSnackbar", {
                  color: "error",
                  text: "Информация не обновлена",
                });
                this.loadingSave = false
              }),
        100
      );
    },
  },
  created() {
    this.loading = true
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'our_legal_entities', disabled: false, to: '/our_legal_entities', exact: true},
      {text: this.ourLeId, disabled: true},
    ])
    this.getOurLeData().then(() => {
      this.$refs.form.validate()
      if (this.ourLe.onecConnection) {
        this.onecConnected = true
      }
      this.loading = false
    })
  },
  computed: {
    formatUpdateTime() {
      if (this.ourLe.updateTime == null) return "";

      return FormatDateTime(this.ourLe.updateTime);
    },
  },
}
</script>

<style>
input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
</style>